module.exports = {
  logBuild: false,
  // This app intentionally passes literal copy to t() and relies on the key
  // itself as the fallback, so next-translate's default missing-key logger
  // floods the console with hundreds of benign warnings. Silence it.
  logger: () => {},
  locales: ["en", "es"],
  defaultLocale: "en",
  pages: {
    "*": [
      "common",
      "vacation",
      "celebration",
      "appreciation",
      "explore",
      "vendor",
      "profile",
      "jobyfine",
      "landing",
    ],
  },
};
